import styled from '@emotion/styled';
import { FilterOptionType } from './ContentFilter';
import { __t } from './i18n';
import { IconConfirm } from './icons';
import Select from './Select';
import { Flex, Icon, MenuItem, Ellipsis } from './styles';

export type FilterType = 'territory' | 'category' | 'order' | 'types' | 'genre';

export interface Filter {
  id: string;
  title: string;
  type: FilterType;
}

const ValueWrapper = styled(Flex)(() => ({
  flexGrow: 1,
  minWidth: 0,
}));

const ValueSummary = styled(Ellipsis)(({ theme }) => ({
  // backgroundColor: 'rgba(0,0,200,.3)',
  fontWeight: theme.font.weight.regular,
  opacity: .5,
  marginRight: '1.5em',
  marginLeft: '.25em',
  fontSize: '.8em',
}));

const labelAll = __t('filter.all');
// const labelNone = __t('filter.none');
const Selected = () => <Icon size="small"><IconConfirm /></Icon>;

export default function FilterSelect({ value, onChange, field, type, label, options }) {
  const displayValue = options.filter((o: FilterOptionType) => {
    return Array.isArray(value) ? value.includes(o.value) : value === o.value;
  }).map(({ label }) => label.trim()).join('، ');

  const renderValue = (
    <ValueWrapper align="baseline" justify="space-between">
      {__t(label)}<ValueSummary>{displayValue}</ValueSummary>
    </ValueWrapper>
  );

  return (
    <Flex direction="column">
      <Select
        mb={1}
        value={value}
        onChange={({ target }) => onChange(field, target.value, type)}
        renderValue={renderValue}
      >
        {type === 'multi' && <MenuItem inputSize="small">{labelAll} {displayValue === '' && <Selected />}</MenuItem>}
        {options.map(({ label, value: val }) => (
          <MenuItem key={val} value={val} inputSize="small">
            {label} {(type === 'multi' && value.includes(val) ||
              type === 'single' && value === val) && <Selected />}
          </MenuItem>
        ))}
      </Select>
    </Flex>
  );
}
